module.exports = __webpack_public_path__ + "img/Hammond.b7896746.jpg";